import React, { createElement } from "react";
import { Switch, Route } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import styles from "./authStyle.js";

import ConsoleLoginPage from "../console/LoginPage";

const useStyles = makeStyles(styles);

export default function Pages() {
  const wrapper = React.createRef();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  return (
    <div>
      <div className={classes.wrapper} ref={wrapper}>
        <div className={classes.fullPage}>
          <Switch>
            <Route exact path={"/console/login"} key={"/console/login"}>
              {createElement(ConsoleLoginPage)}
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
}
